export function uniqueId(prepend) {
    let addPrepend = (prepend !== undefined) ? prepend + '-' : '',
        compile = 'id-' + addPrepend + Math.random().toString(36).substr(2, 16);

    if(document.getElementById(compile) !== null){
        return uniqueId(prepend);
    }



    return compile;
}
export function uniqueClass(prepend) {
    let addPrepend = (prepend !== undefined) ? prepend + '-' : '',
        compile = 'cls-' + addPrepend + Math.random().toString(36).substr(2, 16);

    if(classExists(compile)){
        return uniqueClass(prepend);
    }
    return compile;
}

function classExists(c){
    return typeof(c) == "function" && typeof(c.prototype) == "object";
}



// WEBPACK FOOTER //
// ./app/Shared/Resources/Assets/js/helpers/classesAndIds.js